

<template>
    <BaseContainer>
    <BaseContentContainer>
    <h1 class="display-6 text-center">Educational Technology (EdTech)</h1>
    <!-- Intro Section -->
    <!-- <div class="lead text-center mb-5">-->
    <div class="fs-5 mb-4 text-center">
    Educational objectives drive the choice of technology, and technology is selected only when it meaningfully enhances teaching and learning.
    </div>
      <div class="accordion" id="teachingAccordion">
    <div v-for="item in accordions" :key="item.id">

       
        <GenericAccordion :object="item">
             <div class="" v-for="(object2, index) in item.description_card" :key="index">
             <BlockHorizontalText :object="object2"></BlockHorizontalText><br>
          </div>
        </GenericAccordion>
            </div></div>
    </BaseContentContainer>
</BaseContainer>


       
</template>

<script>
import BaseContainer  from '@/components/BaseContainer.vue';
import BaseContentContainer  from '@/components/BaseContentContainer.vue';
import GenericAccordion  from '@/components/GenericAccordion.vue';
import accordionsData from '@/data/edtech_main_accordions'

import BlockHorizontalText  from '@/components/BlockHorizontalText.vue'; 
export default {
  name: 'EdTech_View',

    components: {
       BaseContainer,BaseContentContainer,GenericAccordion,BlockHorizontalText, 
      //GenericAccordion , GenericCard, 
  },

  data() {
     return {
    accordions: accordionsData,

      
    };
   
  },
  methods: {
    

}
};

</script>

//Ideal content width: 700px – 1000px
<style scoped>
.my-container {
  width: 980px;
  /*background: lightgoldenrodyellow; */
  border: 1px solid black;
}
</style>
